export const TOUTIAO_COLMUNS = [
  {
    title: '账号/ID',
    key: 'adAccount',
    width: 188
  },
  {
    title: '账号余额',
    key: 'accountMoney',
    width: 72
  },
  {
    title: '在投计划数',
    key: 'validPlanCounts',
    width: 84
  },
  {
    title: '账号日预算',
    key: 'budget',
    width: 180
  },
  {
    title: '账面消耗',
    key: 'paperAmount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '展示量',
    key: 'pv',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击数',
    key: 'click',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    sortable: 'custom',
    width: 94
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    sortable: 'custom',
    width: 124
  },
  {
    title: '转化数',
    key: 'convertNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '转化成本',
    key: 'convertCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '转化率',
    key: 'convertRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120'
  },
  {
    title: '管理人员',
    key: 'opNames',
    width: '120'
  }
]

export const TENCENT_COLMUNS = [
  {
    title: '账号/ID',
    key: 'adAccount',
    width: 188
  },
  {
    title: '账号余额',
    key: 'accountMoney',
    width: 72
  },
  {
    title: '在投计划数',
    key: 'validPlanCounts',
    width: 84
  },
  {
    title: '账号日预算',
    key: 'budget',
    width: 180
  },
  {
    title: '账面消耗',
    key: 'paperAmount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '展示量',
    key: 'pv',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击数',
    key: 'click',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    sortable: 'custom',
    width: 94
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    sortable: 'custom',
    width: 124
  },
  {
    title: '转化数',
    key: 'convertNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '转化成本',
    key: 'convertCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '转化率',
    key: 'convertRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120'
  },
  {
    title: '管理人员',
    key: 'opNames',
    width: '120'
  }
]

export const KS_COLMUNS = [
  {
    title: '账号/ID',
    key: 'adAccount',
    width: 188
  },
  {
    title: '账号余额',
    key: 'accountMoney',
    width: 72
  },
  {
    title: '在投计划数',
    key: 'validPlanCounts',
    width: 84
  },
  {
    title: '账号日预算',
    key: 'budget',
    width: 180
  },
  {
    title: '分日预算',
    key: 'day_budget_schedule',
    align: 'left',
    type: 'basic',
    width: 170
  },
  {
    title: '账面消耗',
    key: 'paperAmount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '封面展示量',
    key: 'pv',
    sortable: 'custom',
    width: 108
  },
  {
    title: '封面点击量',
    key: 'click',
    sortable: 'custom',
    width: 108
  },
  {
    title: '素材展示量',
    key: 'materialPv',
    sortable: 'custom',
    width: 108
  },
  {
    title: '封面点击率',
    key: 'photo_click_ratio',
    sortable: 'custom',
    width: 108
  },
  {
    title: '平均封面点击单价',
    key: 'photo_click_cost',
    sortable: 'custom',
    width: 144
  },
  {
    title: '平均千次封面展示均价',
    key: 'impression_1k_cost',
    sortable: 'custom',
    width: 168
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '激活率',
    key: 'activeRate',
    sortable: 'custom',
    width: 94
  },
  {
    title: '注册数',
    key: 'register',
    sortable: 'custom',
    width: 94
  },
  {
    title: '注册成本',
    key: 'registerCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '付费次数',
    key: 'payCount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '付费金额',
    key: 'payAmount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120'
  },
  {
    title: '管理人员',
    key: 'opNames',
    width: '120'
  }
]

export const BAIDU_COLMUNS = [
  {
    title: '账号/ID',
    key: 'adAccount',
    width: 188
  },
  {
    title: '账号余额',
    key: 'accountMoney',
    width: 72
  },
  {
    title: '在投计划数',
    key: 'validPlanCounts',
    width: 84
  },
  {
    title: '账号日预算',
    key: 'budget',
    width: 180
  },
  {
    title: '账面消耗',
    key: 'paperAmount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '展示量',
    key: 'pv',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击数',
    key: 'click',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    sortable: 'custom',
    width: 94
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    sortable: 'custom',
    width: 124
  },
  {
    title: '转化数',
    key: 'convertNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '转化成本',
    key: 'convertCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '转化率',
    key: 'convertRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '表单提交成功量',
    key: 'aggrFormSubmitSuccess',
    sortable: 'custom',
    width: 124
  },
  {
    title: '表单提交成功成本',
    key: 'aggrFormSubmitSuccessCost',
    sortable: 'custom',
    width: 134
  },
  {
    title: '微信调起按钮点击量',
    key: 'weixinAppButtonConversions',
    sortable: 'custom',
    width: 154
  },
  {
    title: '微信调起按钮点击成本',
    key: 'weixinAppButtonConversionsCost',
    sortable: 'custom',
    width: 154
  },
  {
    title: '微信复制按钮点击量',
    key: 'weixinCopyConversions',
    sortable: 'custom',
    width: 144
  },
  {
    title: '微信复制按钮点击成本',
    key: 'weixinCopyConversionsCost',
    sortable: 'custom',
    width: 154
  },
  {
    title: '微信加粉成功量',
    key: 'weixinFollowSuccessConversions',
    sortable: 'custom',
    width: 134
  },
  {
    title: '微信加粉成功成本',
    key: 'weixinFollowSuccessConversionsCost',
    sortable: 'custom',
    width: 134
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120'
  },
  {
    title: '管理人员',
    key: 'opNames',
    width: '120'
  }
]

export const UC_COLMUNS = [
  {
    title: '账号/ID',
    key: 'adAccount',
    width: 188
  },
  {
    title: '账号余额',
    key: 'accountMoney',
    width: 72
  },
  {
    title: '在投计划数',
    key: 'validPlanCounts',
    width: 84
  },
  {
    title: '账号日预算',
    key: 'budget',
    width: 180
  },
  {
    title: '账面消耗',
    key: 'paperAmount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    width: 94
  },
  {
    title: '展示量',
    key: 'pv',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击数',
    key: 'click',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    width: 84
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    sortable: 'custom',
    width: 94
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    sortable: 'custom',
    width: 124
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '转化数',
    key: 'convertNum',
    sortable: 'custom',
    width: 84
  },
  {
    title: '转化成本',
    key: 'convertCost',
    sortable: 'custom',
    width: 94
  },
  {
    title: '深度转化数',
    key: 'deepBindingNum',
    sortable: 'custom',
    width: 98
  },
  {
    title: '深度转化成本',
    key: 'deepBindCost',
    sortable: 'custom',
    width: 112
  },
  {
    title: '首日ROI',
    key: 'day1Roi',
    sortable: 'custom',
    width: 84
  },
  {
    title: '累计ROI',
    key: 'sumRoi',
    sortable: 'custom',
    width: 84
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120'
  },
  {
    title: '管理人员',
    key: 'opNames',
    width: '120'
  }
]
